import request from '@/utils/service'

export function getBanner(data) {
  return request({
    url: `/banner/detail`,
    method: 'get',
    params: data
  })
}

export function getBanners(data) {
  return request({
    url: '/banner/list',
    method: 'get',
    params: data
  })
}

export function submitBanner(data) {
  if (data.type === 3) {
    data.content = '.'
  }

  return request({
    url: '/banner/add',
    method: 'post',
    data
  })
}

export function deleteBanner(data) {
  return request({
    url: '/banner/delete',
    method: 'post',
    data
  })
}

export function changeBannerPutaway(data) {
  return request({
    url: '/banner/update',
    method: 'post',
    data
  })
}

export function bannerUpdate(data) {
  return request({
    url: '/banner/update',
    method: 'post',
    data
  })
}
